export default __webpack_public_path__ + "static/media/organization.d3cdb849.svg";